<template>
    <div class="flex justify-content-between align-items-center mx-5 my-3 flex-wrap">
        <h2 class="text-secondary text-center sm:text-left w-full sm:w-auto">Configurazione (gruppo {{ groupID }})</h2>
        <div class="flex w-full sm:w-auto justify-content-end mt-2 sm:mt-0">
            <Button label="ALL" icon="pi pi-list" @click="vediTutto()" class="p-button-primary w-full sm:w-5 mx-1" />
            <Button label="NEW" icon="pi pi-plus" @click="nuovaSync()" class="p-button-primary w-full sm:w-5 mx-1" />
            <Button label="LOG" icon="pi pi-align-left" @click="showLogs()" class="p-button-primary w-full sm:w-5 mx-1" />
        </div>
    </div>


    <div v-if="loading" class="col-12 h-30rem flex justify-content-center align-items-center">
        <ProgressSpinner style="width: 50px; height: 50px" strokeWidth="8" fill="transparent"
            animationDuration=".5s" aria-label="Custom ProgressSpinner" />
    </div>

    <DataTable v-if="!loading" :value="sync" paginator :rows="15" showGridlines class="file-table">
        <Column field="tabella_sorgente" header="Sorgente">
            <template #body="slotProps">
                {{ eliminaUnderscore(slotProps.data.tabella_sorgente) }}
            </template>
        </Column>
        <Column field="tabella_destinazione" header="Destinatario">
            <template #body="slotProps">
                {{ eliminaUnderscore(slotProps.data.tabella_destinazione) }}
            </template>
        </Column>
        <Column field="table_name" header="Nome Tabella" style="width: 25%"></Column>
        <Column field="type" header="Metodo"></Column>
        <!-- <Column field="group_id" header="Gruppo"></Column> -->
        <Column field="orderID" header="Order ID"></Column>
        <Column field="azioni" header="Azioni" style="min-width: 8rem">
            <template #body="slotProps">
                <button @click="editItem(slotProps.data)" class="p-button p-button-text">
                    <i class="pi pi-pencil mr-1" style="color:black"></i> Modifica
                </button>
                
                <button @click="deleteGroupTableConfirm(slotProps.data.group_id, slotProps.data.table_name)" class="p-button p-button-text" style="color:red">
                    <i class="pi pi-trash mr-1" style="color:red"></i> Elimina
                </button>
            </template>
        </Column>
    </DataTable>

    <template>
        <div>
            <Dialog :visible="isDialogVisible" @hide="isDialogVisible = false" header="Modifica" :closable="false" :style="{ width: '50rem' }">

                <span class="text-surface-500 dark:text-surface-400 block mb-8">Aggiorna record con ID: {{ selectedItem.id }}</span>

                <div class="flex justify-content-around align-items-center gap-x-4 mb-4">
                    <label for="src" class="font-semibold w-24 flex-1">Database Sorgente</label>
                    <Dropdown 
                        id="src" 
                        class="flex-1 p-inputtext p-component" 
                        v-model="selectedItem.source_db_id" 
                        :options="db" 
                        optionLabel="dbname" 
                        placeholder="Seleziona un database"
                    />
                </div>
                
                <div class="flex justify-content-around align-items-center gap-x-4 mb-4">
                    <label for="src" class="font-semibold w-24 flex-1">Database Destinatario</label>
                    <Dropdown 
                        id="src" 
                        class="flex-1 p-inputtext p-component" 
                        v-model="selectedItem.destination_db_id" 
                        :options="db" 
                        optionLabel="dbname" 
                        placeholder="Seleziona un database"
                    />
                </div>

                <div class="flex justify-content-around align-items-center gap-x-4 mb-4">
                    <label for="src" class="font-semibold w-24 flex-1">Tabella</label>
                    <InputText id="src" autocomplete="off" class="flex-1" v-model="selectedItem.table_name"/>
                </div>

                <div class="flex justify-content-around align-items-center gap-x-4 mb-4">
                    <label for="src" class="font-semibold w-24 flex-1">Metodo</label>
                    <select id="src" class="flex-1 p-inputtext p-component" v-model="selectedItem.type">
                        <option value="sync">Sync</option>
                        <option value="append">Append</option>
                        <option value="delete">Delete</option>
                        <option value="pendv2">Append V.2</option>
                        <option value="move">Move</option>
                    </select>
                </div>

                <div class="flex justify-content-around align-items-center gap-x-4 mb-4">
                    <label for="src" class="font-semibold w-24 flex-1">Gruppo</label>
                    <InputText id="src" autocomplete="off" class="flex-1" v-model="selectedItem.group_id"/>
                </div>

                <div class="flex justify-content-around align-items-center gap-x-4 mb-4">
                    <label for="src" class="font-semibold w-24 flex-1">Order ID</label>
                    <InputText id="src" autocomplete="off" class="flex-1" v-model="selectedItem.orderID"/>
                </div>
                <div class="flex justify-content-end align-items-center gap-x-4 my-4">
                    <button @click="isDialogVisible = false" class="p-button p-button-text">Chiudi</button>
                    <button @click="salvaModifiche(selectedItem)" class="p-button p-button-text">Salva</button>
                </div>
            </Dialog>
        </div>
    </template>
  </template>
  
  <script>
    import { ref, computed, getCurrentInstance, onMounted } from "vue";
    import SyncService from "../../../services/ask-database-sync/database-sync";
    import router from '@/router'
    import Dialog from "primevue/dialog";
    import Button from 'primevue/button';
    import ProgressSpinner from 'primevue/progressspinner';
    import { useRoute } from 'vue-router';
    import Dropdown from 'primevue/dropdown'
    import { useConfirm } from "primevue/useconfirm";

    export default {

        components: {
            Dialog,
            Button,
            ProgressSpinner,
            Dropdown
        },
        setup() {
            const instance = getCurrentInstance();
            const eventBus = instance.appContext.config.globalProperties.$eventBus;
            const sync = ref([]);
            const isDialogVisible = ref(false);
            const selectedItem = ref(null);
            const loading = ref(true);
            const route = useRoute();
            const groupID = ref(route.params.group_id);
            const db = ref([]);
            const confirm = useConfirm();
            
            const service = new SyncService(eventBus);

            const init = () => {
                service.getSyncTable(groupID.value).then((data) => {
                    sync.value = data;
                    loading.value = false;
                });
    
                service.getDatabaseDetails().then(data => {
                    db.value = data;
                });
            }

            init();


            const editItem = (item=null) => {
                
                if(item) {
                    isDialogVisible.value = true;
                    selectedItem.value = item;
                } else {
                    selectedItem.value = {
                        "id": null,
                        "table_name": "",
                        "source_db_id": 0,
                        "destination_db_id": 0,
                        "type": "delete",
                        "group_id": groupID.value ?? 0,
                        "orderID": null
                    }
                    isDialogVisible.value = true;
                }
            };

            const showLogs = () => {
                // router.push('databaseSyncLogs');
                router.push({name: 'databaseSyncLogsGroup', params: {group_id: groupID.value}});
            }

            const nuovaSync = () => {
                editItem();
            }

            const vediTutto = () => {
                router.push('/databaseSync');

                service.getSyncTable().then((data) => {
                    sync.value = data;
                    loading.value = false;
                });
            }

            const salvaModifiche = (itemUpdated) => {

                if(itemUpdated.id) {
                    service.updateSyncTable(itemUpdated).then(() => {
                        isDialogVisible.value = false;
                        init();
                    });
                } else {
                    service.saveSyncTable(itemUpdated).then(() => {
                        isDialogVisible.value = false;
                        init();
                    });
                }
            }

            const eliminaUnderscore = (str) => {
                if(str) {
                    return str.replaceAll('_', ' ');
                }
            }

            const deleteGroupTable = (group_id, table) => {
                service.eliminaTabellaGruppo(group_id, table);
                init();
            }

            const deleteGroupTableConfirm = (group_id, table) => {
                confirm.require({
                    message: `Sei sicuro di voler eliminare la tabella ${table} del gruppo ${group_id}?`,
                    header: 'Eliminazione',
                    icon: 'pi pi-exclamation-triangle',
                    accept: () => {
                        deleteGroupTable(group_id, table);
                    },
                    reject: () => {
                        console.log("Eliminazione annullata");
                    }
                });
            }

            return {
                sync,
                editItem,
                isDialogVisible,
                selectedItem,
                salvaModifiche,
                showLogs,
                loading,
                nuovaSync,
                eliminaUnderscore,
                groupID,
                vediTutto,
                db,
                init,
                deleteGroupTable,
                deleteGroupTableConfirm
            }
        }
    };
    </script>
    
    <style scoped>
    /* Stile del tuo componente */
  </style>